/* BYKSKI.US — saved parts, organized into builds (2.23.0)
   Device-local, no account required: most buyers are signed out, and a list that needs an
   account is a list nobody keeps. A shopper can keep several named builds ("Main rig",
   "Server 2U") and put a part in any of them, or in more than one.
   A snapshot (title, SKU, image) is stored at add time so the list renders instantly; price and
   availability are refreshed from /products/<handle>.js on the list page, because a saved price
   that has gone stale is worse than no price.
   Storage: bk_builds_v1 = { active: id, builds: [{ id, name, created, items: [item] }] }.
   The 2.x single list (bk_wishlist_v1) is migrated once into a build called "Saved parts". */
(function () {
  var KEY = 'bk_builds_v1', OLD = 'bk_wishlist_v1', DEFAULT_NAME = 'Saved parts';

  function uid() { return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function fresh(name) { return { id: uid(), name: name || DEFAULT_NAME, created: Date.now(), items: [] }; }

  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
    if (!s || !Array.isArray(s.builds)) {
      var first = fresh(DEFAULT_NAME);
      try { var old = JSON.parse(localStorage.getItem(OLD)); if (Array.isArray(old)) first.items = old; } catch (e) {}
      s = { active: first.id, builds: [first] };
      save(s, true);
    }
    if (!s.builds.length) { var b = fresh(DEFAULT_NAME); s.builds.push(b); s.active = b.id; }
    if (!s.builds.some(function (b) { return b.id === s.active; })) s.active = s.builds[0].id;
    return s;
  }
  function save(s, quiet) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    if (!quiet) document.dispatchEvent(new CustomEvent('bk:wishlist', { detail: { state: s } }));
  }
  function find(s, id) { return s.builds.filter(function (b) { return b.id === id; })[0] || null; }
  function inBuild(b, handle) { return b.items.some(function (i) { return i.handle === handle; }); }

  var API = {
    /* Builds */
    builds: function () { return load().builds; },
    build: function (id) { return find(load(), id); },
    activeId: function () { return load().active; },
    setActive: function (id) { var s = load(); if (find(s, id)) { s.active = id; save(s); } },
    createBuild: function (name, items) {
      var s = load(), b = fresh(String(name || '').trim().slice(0, 60) || 'Build ' + (s.builds.length + 1));
      if (Array.isArray(items)) b.items = items;
      s.builds.push(b); s.active = b.id; save(s); return b.id;
    },
    renameBuild: function (id, name) {
      var s = load(), b = find(s, id), n = String(name || '').trim().slice(0, 60);
      if (b && n) { b.name = n; save(s); }
    },
    deleteBuild: function (id) {
      var s = load();
      s.builds = s.builds.filter(function (b) { return b.id !== id; });
      save(s); /* load() on the next read restores a default build and a valid active id */
    },
    /* Items */
    addTo: function (id, item) {
      var s = load(), b = find(s, id);
      if (b && !inBuild(b, item.handle)) { b.items.unshift(item); save(s); }
    },
    removeFrom: function (id, handle) {
      var s = load(), b = find(s, id);
      if (b) { b.items = b.items.filter(function (i) { return i.handle !== handle; }); save(s); }
    },
    move: function (handle, fromId, toId) {
      var s = load(), from = find(s, fromId), to = find(s, toId);
      if (!from || !to || from === to) return;
      var item = from.items.filter(function (i) { return i.handle === handle; })[0];
      if (!item) return;
      from.items = from.items.filter(function (i) { return i.handle !== handle; });
      if (!inBuild(to, handle)) to.items.unshift(item);
      save(s);
    },
    buildsWith: function (handle) {
      return load().builds.filter(function (b) { return inBuild(b, handle); }).map(function (b) { return b.id; });
    },
    /* The 2.x single-list calls, kept so nothing that used them breaks */
    all: function () {
      var seen = {}, out = [];
      load().builds.forEach(function (b) { b.items.forEach(function (i) { if (!seen[i.handle]) { seen[i.handle] = 1; out.push(i); } }); });
      return out;
    },
    count: function () { return API.all().length; },
    has: function (handle) { return API.buildsWith(handle).length > 0; },
    add: function (item) { API.addTo(API.activeId(), item); },
    remove: function (handle) {
      var s = load();
      s.builds.forEach(function (b) { b.items = b.items.filter(function (i) { return i.handle !== handle; }); });
      save(s);
    },
    toggle: function (item) {
      if (API.has(item.handle)) { API.remove(item.handle); return false; }
      API.add(item); return true;
    },
    clear: function () { var s = load(), b = find(s, s.active); if (b) { b.items = []; save(s); } }
  };
  window.BKWishlist = API;

  /* ---------- Heart buttons ---------- */
  function syncButton(btn) {
    var on = API.has(btn.dataset.handle);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('data-on', on ? 'true' : 'false');
    var label = btn.querySelector('[data-bk-wish-label]');
    if (label) label.textContent = on ? (btn.dataset.labelOn || 'Saved') : (btn.dataset.labelOff || 'Save');
    var t = on ? 'Saved: choose builds' : 'Save to a build';
    btn.setAttribute('title', t);
    if (!label) btn.setAttribute('aria-label', t);
  }
  function syncAll() {
    document.querySelectorAll('[data-bk-wish]').forEach(syncButton);
    var n = API.count();
    document.querySelectorAll('[data-bk-wish-count]').forEach(function (el) {
      el.textContent = n;
      if (n === 0) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
    });
  }

  /* ---------- Build picker ----------
     The first click saves to the current build straight away (one click, as before) and opens the
     picker so the part can go into another build too. A click on a part already saved opens the
     picker rather than silently un-saving it from every build. */
  var pop = null, popItem = null, popBtn = null;
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function closePop() { if (pop) { pop.remove(); pop = null; popItem = null; if (popBtn) popBtn.focus(); popBtn = null; } }
  function drawPop() {
    if (!pop) return;
    var have = API.buildsWith(popItem.handle);
    pop.innerHTML =
      '<div class="bkb-pop__h"><span>Save to a build</span><button type="button" class="bkb-pop__x" data-pop-close aria-label="Close">&times;</button></div>' +
      '<div class="bkb-pop__list">' + API.builds().map(function (b) {
        var on = have.indexOf(b.id) > -1;
        return '<label class="bkb-pop__row"><input type="checkbox" data-pop-build="' + b.id + '"' + (on ? ' checked' : '') + '>' +
          '<span class="bkb-pop__name">' + esc(b.name) + '</span><span class="bkb-pop__n">' + b.items.length + '</span></label>';
      }).join('') + '</div>' +
      '<form class="bkb-pop__new" data-pop-new><input type="text" maxlength="60" placeholder="New build name" aria-label="New build name"><button type="submit">Add</button></form>' +
      '<a class="bkb-pop__go" href="' + (window.BK_BUILDS_URL || '/pages/wishlist?view=wishlist') + '">See my builds</a>';
  }
  function place(btn) {
    var r = btn.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight;
    var left = Math.min(Math.max(8, r.right - w), window.innerWidth - w - 8);
    var top = r.bottom + 8;
    if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 8);
    pop.style.left = left + 'px'; pop.style.top = top + 'px';
  }
  function openPop(btn, item) {
    closePop();
    popItem = item; popBtn = btn;
    pop = document.createElement('div');
    pop.className = 'bkb-pop'; pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-label', 'Save to a build');
    document.body.appendChild(pop);
    drawPop(); place(btn);
    var first = pop.querySelector('input'); if (first) first.focus();
  }

  function itemFrom(btn) {
    return {
      handle: btn.dataset.handle, id: btn.dataset.id, title: btn.dataset.title, sku: btn.dataset.sku || '',
      price: btn.dataset.price || '', image: btn.dataset.image || '',
      url: btn.dataset.url || ('/products/' + btn.dataset.handle), added: Date.now()
    };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bk-wish]') : null;
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var item = itemFrom(btn);
      if (pop && popItem && popItem.handle === item.handle) { closePop(); return; }
      if (!API.has(item.handle)) API.add(item);
      openPop(btn, item);
      return;
    }
    if (!pop) return;
    if (e.target.closest('[data-pop-close]') || !pop.contains(e.target)) closePop();
  });
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-pop-build]');
    if (!cb || !popItem) return;
    if (cb.checked) API.addTo(cb.dataset.popBuild, popItem); else API.removeFrom(cb.dataset.popBuild, popItem.handle);
    drawPop();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-pop-new]');
    if (!f || !popItem) return;
    e.preventDefault();
    var name = f.querySelector('input').value.trim();
    if (!name) return;
    API.addTo(API.createBuild(name), popItem);
    drawPop();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop) closePop(); });
  window.addEventListener('resize', function () { if (pop && popBtn) place(popBtn); });
  window.addEventListener('scroll', function () { if (pop && popBtn) place(popBtn); }, { passive: true });

  document.addEventListener('bk:wishlist', syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
  /* Another tab changed it: tell this page's listeners too */
  window.addEventListener('storage', function (e) { if (e.key === KEY) document.dispatchEvent(new CustomEvent('bk:wishlist')); });
})();
